module.exports = __webpack_public_path__ + "img/SEJ_Eventos_eliminar opcion.bd75474b.svg";